import { School } from 'lucide-react';
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm';

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-b from-blue-50 to-blue-100">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center">
          <School className="h-12 w-12 text-primary" />
          <h1 className="mt-4 text-3xl font-bold">School Manager</h1>
          <p className="mt-2 text-muted-foreground">
            Reset your password
          </p>
        </div>
        <ForgotPasswordForm />
      </div>
    </div>
  );
}